import { forwardRef } from "react";
import DatePicker from "react-datepicker";

const CustomInput = forwardRef(function CustomInput(
  { value, onClick, onChange, name },
  ref
) {
  return (
    <input
      value={value}
      className="form-control pl-8 bg-[url('./assets/icons/datePicker.svg')] bg-no-repeat focus:outline-blue-600 focus:ring-blue-600 bg-[center_left_10px] cursor-pointer"
      placeholder={name === "startDate" ? "Start Date" : "Ends On"}
      onClick={onClick}
      onChange={onChange}
      ref={ref}
    />
  );
});

const CustomDatePicker = ({ name, value, selected, onChange, minDate }) => {
  return (
    <DatePicker
      name={name}
      value={value}
      selected={selected}
      Clearable
      customInput={<CustomInput />}
      onChange={onChange}
      minDate={minDate}
    />
  );
};

export default CustomDatePicker;
